import React from 'react';
import PropTypes from 'prop-types';
import * as UTILS_THEMES from './../utils/utilsThemes.js';

const Logo = ({ theme, isEmBlue }) => {
  const getFullLogoURL = theme =>
    UTILS_THEMES.getCurrentThemeURL(theme) +
    'globals/src/images/logos/logo_MDirector_header_trans.png';

  const getMiniLogoURL = theme =>
    UTILS_THEMES.getCurrentThemeURL(theme) +
    'globals/src/images/logos/logo_MDirector_mini_trans.png';

  return (
    <div className="logo__container">
      {!isEmBlue && (
        <img
          alt="MDirector"
          src={getFullLogoURL(theme)}
          className="logo__image logo--full"
          width="150"
        />
      )}
      {!isEmBlue && (
        <img
          alt="MDirector"
          src={getMiniLogoURL(theme)}
          className="logo__image logo--mini"
          width="30"
        />
      )}
    </div>
  );
};

Logo.propTypes = { theme: PropTypes.string.isRequired, isEmBlue: PropTypes.bool };

export default Logo;
